<div class="state-popup">
  <app-state-displayer-column-names
    [type]="'Map'"
    (checkboxUpdate)="updateAllIncidentDevices($event)"
    [hasCheckbox]="hasHeaderCheckbox()"
  ></app-state-displayer-column-names>
  @if (isLoading()) {
    @for (_ of [].constructor(6); track $index) {
      <div class="skeleton-placeholders">
        <app-state-displayer-skeleton-line
          type="Map"
        ></app-state-displayer-skeleton-line>
      </div>
    }
  }
  @if (!isLoading()) {
    <div
      class="data"
      [infiniteScroll]="loadMore"
      [scrollRatio]="0.4"
      [initScrollThreshold]="50"
    >
      @for (
        currentState of currentStates;
        track currentState.deviceId;
        let i = $index
      ) {
        <div (click)="deviceIdClicked(currentState)">
          <div>
            @if (i) {
              <div class="information-divider"></div>
            }
            <app-state-displayer
              [isSelectionOn]="isSelectionOn"
              (handleDevice)="onHandleDevice($event)"
              [(currentState)]="currentStates[i]"
              [isChecked]="allChecked"
              [mapDisplay]="true"
              (navigate)="onChangeTab($event)"
            ></app-state-displayer>
          </div>
        </div>
      }
    </div>
  }
</div>
